<div class="payment-order-dialog-wrapper">
  <div class="payment-order-dialog-title d-flex align-items-center">
    <h2 class="p-0 me-2" mat-dialog-title>{{ 'orders.payment.paymentForSelection' | translate }}</h2>
  </div>

  <mat-dialog-content>
    <div class="payment-order-content">
      <div class="payment-order-refunds-list">
        <app-summary-list
          [items]="allSummaryItems"
          [title]="''"
          [summaryLabelCallback]="summaryLabel"
          [maxDisplayedItems]="maxDisplayedLines"
        >
        </app-summary-list>
      </div>

      <div class="payment-order-customer-selection mb-3">
        <app-payment-customer-section
          [selectionTitle]="'orders.customerPayer'"
          [selectedCustomer]="selectedCustomer()"
          [isEditMode]="true"
          (customerChange)="onCustomerChange($event)"
        ></app-payment-customer-section>
      </div>
      @if(form && paymentModes().length > 0) {
      <app-payment-method-section
        [selectionTitle]="'orders.paymentMethod'"
        [isEditMode]="true"
        [form]="form"
        [paymentModes$]="paymentModes$"
        [totalAmount$]="totalAmount$"
        [cancelPaymentModes]="paymentModes()"
        [availablePaymentModes]="availablePaymentModes"
        [selectedPaymentMode]="selectedPaymentMode"
        [displayMode]="'detailed'"
        [paymentTypes]="paymentTypes"
        (paymentModeChange)="paymentModeChange($event)"
        (amountToReturnChange)="amountToReturn = $event"
      ></app-payment-method-section>
      }

      <div class="payment-order-footer" id="payment-order-footer">
        <app-validated-form-row [isRemoveHidden]="true" [isEditHidden]="true">
          <ng-template #labelTemp>
            <div class="payment-footer-label">
              <span>{{ 'shared.payment.totalAmount' | translate }}:</span>
              <span class="label-bold">
                {{ totalAmount | currency : 'EUR' : 'symbol' : '0.2-2' : 'fr' }}
              </span>
            </div>
          </ng-template>
        </app-validated-form-row>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions [align]="'end'">
    <div class="mb-3">
      <button mat-button (click)="onCancel()" class="tick-btn tick-btn-secondary">
        {{ 'shared.actions.cancel' | translate }}
      </button>
      <button
        mat-button
        class="tick-btn tick-btn-primary ms-1"
        (click)="onConfirm()"
        [disabled]="isConfirmDisabled()"
        [appHasRight]="[RightEnum.Payment]"
      >
        <span>{{ 'shared.actions.pay' | translate }}</span>
      </button>
    </div>
  </mat-dialog-actions>
</div>
